import { CaseStudies } from './components/CaseStudies';
import { Contact } from './components/Contact';
import { Cycle } from './components/Cycle';
import { Hero } from './components/Hero';
import { Practices } from './components/Practices';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
import { TechStack } from './components/TechStack';
import { useSiteContent } from './hooks/useSiteContent';
import { t } from './i18n/messages';

export function App() {
  const { content } = useSiteContent();

  return (
    <>
      <a className="skipLink" href="#main">
        {t.skipToContent}
      </a>

      <SiteHeader company={content.company} />

      <main id="main">
        <Hero hero={content.hero} company={content.company} practices={content.practices} />
        <Practices section={content.services} practices={content.practices} />
        <Cycle cycle={content.cycle} />
        <CaseStudies section={content.work} caseStudies={content.caseStudies} />
        <TechStack section={content.stack} groups={content.stackGroups} />
        <Contact section={content.contact} company={content.company} />
      </main>

      <SiteFooter company={content.company} />
    </>
  );
}
